<template>
    <ValidationObserver>
        <form ref="form" @submit.prevent="validate" style="height: 100%">
            <md-toolbar class="md-small md-success">
                <div class="md-toolbar-row">
                    <div class="md-toolbar-section-start">
                        <md-button class="md-icon-button md-success" @click="addNode">
                            <md-icon>post_add</md-icon>
                            <md-tooltip>新增节点</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-success" @click="removeNode">
                            <md-icon>delete</md-icon>
                            <md-tooltip>删除节点</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-success" @click="removeEdge">
                            <md-icon>layers_clear</md-icon>
                            <md-tooltip>删除连接线</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-success" @click="positionNode">
                            <md-icon>ads_click</md-icon>
                            <md-tooltip>跳转根节点</md-tooltip>
                        </md-button>
                        <!-- <md-button class="md-icon-button md-success" @click="gatherNode">
              <md-icon>settings_input_svideo</md-icon>
              <md-tooltip>聚拢节点</md-tooltip>
            </md-button> -->
                        <!-- <md-button class="md-icon-button md-success">
              <md-icon>save</md-icon>
              <md-tooltip>保存</md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-success">
              <md-icon>refresh</md-icon>
              <md-tooltip>刷新</md-tooltip>
            </md-button> -->
                        <!-- <md-button class="md-icon-button md-success" @click="toTask">
              <md-icon>reply_all </md-icon>
              <md-tooltip>返回</md-tooltip>
            </md-button> -->
                    </div>
                    <span class="md-title">任务名称</span>
                    <div class="md-toolbar-section-end">
                        <md-button class="md-icon-button md-success" @click="save">
                            <md-icon>save_as</md-icon>
                            <md-tooltip>保存</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-success">
                            <md-icon>format_indent_decrease</md-icon>
                            <md-tooltip>隐藏左侧栏</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-success">
                            <md-icon>format_indent_increase</md-icon>
                            <md-tooltip>隐藏右侧栏</md-tooltip>
                        </md-button>
                        <md-button v-if="!fullScreenStatus" class="md-icon-button md-success" @click="openFullScreen">
                            <md-icon>fullscreen</md-icon>
                            <md-tooltip>全屏</md-tooltip>
                        </md-button>
                        <md-button v-else class="md-icon-button md-success" @click="closeFullScreen">
                            <md-icon>close_fullscreen</md-icon>
                            <md-tooltip>退出全屏</md-tooltip>
                        </md-button>
                    </div>
                </div>
            </md-toolbar>
            <Split :style="{ height: `${flowHeight}px` }">
                <SplitArea :size="form.id ? 75 : 99" ref="taskArea">
                    <div style="display: flex; width: 100%;position: relative;">
                        <div id="container" ref="container" style="flex: 1" :style="{ height: `${flowHeight}px` }"></div>
                        <!-- <div style="position:absolute;top:0;right:0;width:300px;height:200px;">
              <div id="miniMap" ref="miniMap" ></div>
            </div> -->
                    </div>
                </SplitArea>
                <SplitArea :size="form.id ? 25 : 0" v-show="form.id">
                    <collapse :collapse="['基础信息', '触发条件', '任务步骤']" icon="keyboard_arrow_down" color-collapse="success" class="md-collapse">
                        <template slot="md-collapse-pane-1">
                            <md-field>
                                <label>编 号</label>
                                <md-input v-model="form.id" type="text" disabled> </md-input>
                                <span class="md-helper-text">系统自动生成的元件编号</span>
                            </md-field>
                            <md-field>
                                <label>节点类型</label>
                                <md-select v-model="form.type" name="type" id="type">
                                    <md-option value="Init">初始化节点</md-option>
                                    <md-option value="Common">执行节点</md-option>
                                    <md-option value="Exit">结束节点</md-option>
                                </md-select>
                            </md-field>
                            <md-field>
                                <label>名 称</label>
                                <md-input v-model="form.label" type="text"> </md-input>
                                <span class="md-helper-text">请使用英文/字符,首字母不要使用字符</span>
                            </md-field>
                            <md-field>
                                <label>描 述</label>
                                <md-textarea v-model="form.description" md-autogrow></md-textarea>
                                <span class="md-helper-text">请输入功能说明，回车可换行</span>
                            </md-field>
                        </template>
                        <template slot="md-collapse-pane-2">
                            <Trigger ref="trigger" @updateTrigger="updateTrigger" />
                        </template>
                        <template slot="md-collapse-pane-3">
                            <md-card>
                                <md-card-content>
                                    <v-data-table :headers="headers" :items="tableData"  multi-sort hide-default-footer class="paginated-table table-striped table-hover">
                                        <template v-slot:item._id="{ item }">{{ stepMetaMap[item._id] }}</template>
                                        <template v-slot:item.templateId="{ item }">{{ stepActionMap[item.templateId] }}</template>
                                        <template v-slot:item.type="{ item }">{{ stepTypeMap[item.type] }}</template>
                                        <template v-slot:item.option="{ item }">
                                            <md-button class="md-just-icon md-success md-round md-simple" @click.native="editStep(item)" style="padding-right: 30px;">
                                                <md-icon>edit</md-icon>
                                            </md-button>
                                            <md-button class="md-just-icon md-danger md-round md-simple" @click.native="handleDelete(index)">
                                                <md-icon>close</md-icon>
                                            </md-button>
                                        </template>
                                    </v-data-table>
                                    <!-- 步骤表单 -->
                                    <TaskStepForm ref="stepForm" :showExtDialog="showExtDialog" @close="showExtDialog = false" @confirm="stepConfirm" :treeData="treeData"></TaskStepForm>
                                </md-card-content>
                                <md-card-actions md-alignment-center>
                                    <md-button class="md-just-icon md-success md-round md-simple" @click="showExtDialog = true">
                                        <md-icon>add</md-icon>
                                    </md-button>
                                    <pagination class="pagination-no-border pagination-success md-size-100" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total">
                                    </pagination>
                                </md-card-actions>
                            </md-card>
                        </template>
                    </collapse>
                </SplitArea>
            </Split>
        </form>
        <!-- <TaskNode /> -->
    </ValidationObserver>
</template>
<script>
import { mapState } from 'vuex';
import { Collapse, Pagination } from "@/components";
import { listRoleComponent } from "@/api/component/role_component";
import { listSysComponent } from "@/api/component/sys_component";
import { listUtilComponent } from "@/api/component/util_component";
import { findTypeListBySceneId } from "@/api/device";
import Fuse from "fuse.js";
import meta from "../devicemeta";
import Trigger from "./Trigger";
import GraphInit from "./GraphOption";
import TaskStepForm from "./TaskStepForm";
import { innerAction } from './../SystemAction'
import { sceneAction } from './../SceneAction'
import { innerAction as RoleAction } from './../RoleAction'
import Swal from 'sweetalert2'
let graph = {};

const stepTypeMap = {
    device: "设备",
    tool: "工具",
    role: "角色",
    scene: "场景",
    system: "系统",
};

export default {
    props: {
        sidebarMini: Boolean,
        treeData: {
            type: Array,
            default: () => [],
        },
        sceneId: {
            type: String,
            default: "",
        },
        validateStep: {
            type: Function,
            default: null,
        },
    },
    // inject: ['taskInfo'],
    computed: {
        ...mapState(['global/taskInfo']),
        taskInfo() {
            return this.$store.state.global.taskInfo;
        }
    },
    data() {
        return {
            headers: [
                { text: '对象', align: 'center', value: '_id' },
                { text: '动作', align: 'center', value: 'templateId' },
                { text: '类型', align: 'center', value: 'type' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            form: {},
            checkedEdgeId: "",
            showExtDialog: false,
            meta,
            stepTypeMap,
            attachData: [{
                    info: "分合指示标签状态1",
                },
                {
                    info: "分合指示标签状态2",
                },
                {
                    info: "分合指示标签状态3",
                },
            ],
            tableData: [],
            currentSort: "name",
            currentSortOrder: "asc",
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
            },
            stepPage: {
                perPage: 1000,
                currentPage: 1,
            },
            stepMetaMap: {},
            stepActionMap: {},
            flowMapData: {},
            flowTriggerMap: {},
            searchQuery: "",
            propsToSearch: ["name"],
            searchedData: [],
            fuseSearch: null,
            fullScreenStatus: false,
            flowHeight: 600,
            chooseNodeId: "",
        };
    },
    components: {
        Collapse,
        Pagination,
        TaskStepForm,
        Trigger,
    },
    computed: {
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ?
                this.searchedData.length :
                this.tableData.length;
        },
    },
    methods: {
        gatherNode() {
            const taskTree = this.getTaskJson()
        },
        positionNode() {
            const cells = graph.getCells().filter(item => item.store.data.shape === 'dag-node')
            console.log(cells[0].store.data.position)
            graph.centerCell(cells[0])
        },
        editStep(item) {
            this.showExtDialog = true;
            this.$nextTick(() => {
                this.$refs.stepForm.init(item);
            });
        },
        sortByStepKey(array, key) {
            return array.sort(function(a, b) {
                var x = a[key]; //如果要从大到小,把x,y互换就好
                var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },
        stepConfirm(e) {
            let arr = this.flowMapData[this.form.id] ?? [];

            const numberProperty = ['showTime', 'tipShowTime', 'tipPositionX', 'tipPositionY', 'tipPositionZ']

            for (let property in e) {
                if (numberProperty.includes(property)) {
                    e[property] = Number.parseFloat(e[property])
                }
            }

            if (e.id) {
                const index = arr.findIndex((item) => item.id === e.id);
                const order = Number(e.stepOrder) - 1
                if (order === index || isNaN(order)) {
                    arr[index] = e;
                } else if (order > arr.length) {
                    arr.splice(index, 1)
                    arr.splice(arr.length, 0, e)
                } else {
                    arr.splice(index, 1)
                    arr.splice(order, 0, e)
                }
            } else {
                e.id = `step_${new Date().getTime()}`;
                arr.push(e);
            }
            this.sortByStepKey(arr, 'stepOrder')

            this.flowMapData[this.form.id] = arr;
            this.tableData = arr;
            this.showExtDialog = false;
            this.$forceUpdate()
        },
        updateTrigger(triggerObj) {
            this.flowTriggerMap[this.form.id] = triggerObj;
        },
        initFlow(taskInfo) {
            this.flowMapData = taskInfo.flowMapData ?? {};
            this.flowTriggerMap = taskInfo.flowTriggerMap ?? {};
            graph.fromJSON(taskInfo.flowJsonData);
            const rootNodes = graph.getRootNodes()
            if (rootNodes && rootNodes.length > 0) {
                // graph.centerContent()
                graph.centerCell(rootNodes[0])
            }
        },
        async initStepMapData() {
            const roleRes = await listRoleComponent(this.stepPage);
            const sceneRes = await findTypeListBySceneId({ sceneId: this.$store.state.global.taskInfo.scene, type: 'scene' });
            const sysRes = await listSysComponent(this.stepPage);
            const toolRes = await listUtilComponent(this.stepPage);
            const deviceRes = await findTypeListBySceneId({ sceneId: this.$store.state.global.taskInfo.device, type: 'device' });

            let list = []
                .concat(roleRes.data.rows)
                .concat(sysRes.data.rows)
                .concat(toolRes.data.rows)
                .concat(innerAction)
                .concat(RoleAction)
                .concat(sceneAction);

            const deviceTypeList = deviceRes.data;
            const sceneTypeList = sceneRes.data;

            const action_list = list
                .flatMap((item) => item.action_list)
                .concat(
                    deviceTypeList
                    .concat(sceneTypeList)
                    .flatMap((item) =>
                        item.deviceTypeInfo ? item.deviceTypeInfo.actions : []
                    )
                );

            list = list.concat(deviceTypeList).concat(sceneTypeList);

            this.stepMetaMap = list.reduce((pre, next) => {
                pre[next._id] = next.name;
                return pre;
            }, {});

            this.stepActionMap = action_list.reduce((pre, next) => {
                pre[next.id] = next.name;
                return pre;
            }, {});

            const actionData = action_list.reduce((pre, next) => {
                pre[next.id] = next;
                return pre;
            }, {});

            let mapData = this.flowMapData
            for (let taskId in mapData) {
                let taskNodeActionArr = mapData[taskId]
                taskNodeActionArr.map(item => {
                    if (item.type !== 'system') {
                        Object.assign(item.actionData, actionData[item.actionData.id])
                        item.templateName = actionData[item.actionData.id].name
                    }
                    return item;
                })
                mapData[taskId] = taskNodeActionArr
            }

            this.flowMapData = mapData

            this.stepActionMap['OpenUI'] = '打开UI'
            this.stepActionMap['CloseUI'] = '关闭UI'
            this.stepActionMap['PlayVideo'] = '打开视频'
            this.stepActionMap['PlayAudio'] = '播放音频'
            this.stepActionMap['Delay'] = '延时'
            this.stepActionMap['MoveCamera'] = '移动摄像机'
        },
        init() {
            graph = GraphInit(document.getElementById("container"));
            graph.on("edge:connected", ({ edge }) => {
                edge.attr({
                    line: {
                        strokeDasharray: "",
                    },
                });
            });

            // graph.on("node:change:data", ({ node }) => {
            //   const edges = graph.getIncomingEdges(node);
            //   const { status } = node.getData();
            //   edges?.forEach((edge) => {
            //     if (status === "running") {
            //       edge.attr("line/strokeDasharray", 5);
            //       edge.attr(
            //         "line/style/animation",
            //         "running-line 30s infinite linear"
            //       );
            //     } else {
            //       edge.attr("line/strokeDasharray", "");
            //       edge.attr("line/style/animation", "");
            //     }
            //   });
            // });

            graph.on("edge:click", ({ edge }) => {
                _this.checkedEdgeId = edge.id;
            });

            const _this = this;
            graph.on("node:click", (obj) => {
                const { node } = obj;
                graph.centerCell(node)
                _this.form = node.getData();
                _this.form.id = node.id;
                _this.tableData = _this.flowMapData[node.id] ?
                    _this.flowMapData[node.id] : [];
                _this.$refs.trigger.init(_this.flowTriggerMap[node.id] ?? {});
                _this.$forceUpdate();
            });

            graph.on("blank:click", () => {
                _this.form = {};
                _this.tableData = [];
                _this.$forceUpdate();
            });
        },
        getTaskJson() {
            return graph.toJSON();
        },
        getTaskTree() {
            const rootNodes = graph
                .getRootNodes()
                .map(item => item.id)
                .map(item => {
                    return {
                        pid: 0,
                        id: item,
                        children: []
                    }
                })

            const graphMap = graph
                .getCells()
                .map(item => item.toJSON())
                .filter(item => item.shape === 'dag-edge')
                .reduce((pre, next) => {
                    if (pre[next.source.cell]) {
                        pre[next.source.cell].push(next.target.cell)
                        return pre;
                    }
                    pre[next.source.cell] = [next.target.cell]
                    return pre;
                }, {})

            const buildTree = (node) => {
                let childArr = graphMap[node.id] ?? []
                for (let index = 0; index < childArr.length; index++) {
                    const id = childArr[index];
                    let obj = {
                        pid: node.id,
                        id,
                        children: []
                    }
                    node.children.push(obj)
                    buildTree(obj)
                }
                return node;
            }

            const trees = rootNodes.map(item => buildTree(item))

            return trees;
        },
        updateValue(name, val) {
            this.$emit(`update:${name}`, val);
        },
        addNode() {
            const id = new Date().getTime();
            const node = graph.addNode({
                id,
                shape: "dag-node",
                data: {
                    label: "节点",
                    type: "Init",
                },
                ports: [{
                    id: "1-1",
                    group: "bottom",
                }, ],
            });
            if (this.form.id) {
                const findNode = graph.getNodes().find(item => item.id === this.form.id)
                const { x, y } = findNode.position()
                node.position(x + 250, y)
                graph.centerCell(node)
                return;
            }

            const roots = graph.getRootNodes()
            if (roots && roots.length > 0) {
                const { x, y } = roots[0].position()
                node.position(x + 200, y)
                graph.centerCell(node)
            }
        },
        removeEdge() {
            graph.removeEdge(this.checkedEdgeId);
            this.checkedEdgeId = "";
        },
        removeNode() {
            graph.removeNode(this.form.id);
        },
        save() {
            // this.$refs.basicInfoForm.submitBasicProperty('save')
            this.validateStep('step2', true);
            return true
        },
        openFullScreen() {
            this.fullScreenStatus = true;
            this.$refs["form"].$el.requestFullscreen().then(() => {
                const dom = this.$refs.form.$el;
                this.flowHeight = dom.clientHeight;
            });
        },
        closeFullScreen() {
            this.fullScreenStatus = false;
            document.exitFullscreen().then(() => {
                this.flowHeight = 600;
            });
        },
        validate() {
            return true;
        },
        async handleDelete(index) {
            let result = await Swal.fire({
                title: '删除信息',
                text: `确认删除该步骤？`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: '确 定',
                cancelButtonText: '取 消',
                buttonsStyling: false
            })

            if (!result.value) return;

            this.tableData.splice(index, 1);
            this.$notify({
                timeout: 1500,
                message: "删除成功",
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "bottom",
                type: "success",
            });
        },
    },
    to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
            highBound = this.total;
        }
        return highBound;
    },
    from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
        return this.searchedData.length > 0 ?
            this.searchedData.length :
            this.tableData.length;
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name", "email"],
            threshold: 0.3,
        });
        this.init();
        this.initStepMapData();
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery(value) {
            let result = this.tableData;
            if (value !== "") {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchedData = result;
        },
        form: {
            deep: true,
            handler: function(val) {
                const emptyObj = (obj) => {
                    for (let property in obj) {
                        return false;
                    }
                    return true;
                };
                if (emptyObj(val)) {
                    return;
                }
                const cell = graph.getCellById(val.id);
                if (cell) {
                    cell.setData(val);
                }
            },
        },
    },
};
</script>
<style lang="css" scoped>
*:fullscreen,
*:-webkit-full-screen,
*:-moz-full-screen {
    background-color: rgba(255, 255, 255, 1);
}

.md-toolbar {
    color: #808990 !important;
    padding: 1px 15px;
    border-radius: 1px;
    position: static;
    border-bottom: 1px solid rgb(0 0 0 / 3%);
}

.md-tree {
    padding: 15px 15px;
}

.md-collapse {
    padding-left: 15px;
}

.span {
    min-width: 60px;
    margin: 30px;
    display: inline-block;
    text-align: center;
}

.md-card {
    margin: 0px;
    box-shadow: 0 0 0 0 rgb(0 0 0 / 14%);
}

.md-card .md-card-actions {
    border-top: 0px;
}

.md-card .md-card-content {
    padding: 25px 0px;
}

.md-card .md-card-content .extprop {
    padding-top: 0px !important;
}

.md-icon-text-button {
    width: 80px;
}

.md-dialog /deep/.md-dialog-container {
    padding: 30px;
    min-width: 650px;
    min-height: 650px;
}

.md-collapse-content {
    padding: 0px 0px;
}

.md-collapse-content .cols-extprop {
    padding: 0px 0px;
}

.md-collapse-content p {
    padding-top: 12px;
}

.md-form-label-ext {
    padding-top: 25px;
}
/*#container{left:0 !important; top:0 !important;}*/
</style>